import classNames from 'classnames';
import React from 'react';
import {useShallow} from 'zustand/react/shallow';

import StudentHomepageSidebarContent from './StudentHomepageSidebarContent';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

export default function StudentHomepageSidebarMobile() {
  const {isSidebarExpanded, setIsSidebarExpanded} = useStudentDashboard(
    useShallow((state) => ({
      isSidebarExpanded: state.isSidebarExpanded,
      setIsSidebarExpanded: state.setIsSidebarExpanded
    }))
  );

  return (
    <>
      <div
        className={classNames(
          'fixed! top-x0 left-x0 z-10 h-screen w-screen overlay-70 transition-opacity duration-200',
          {
            'cursor-pointer opacity-100': isSidebarExpanded,
            'pointer-events-none opacity-0': !isSidebarExpanded
          }
        )}
        onClick={() => {
          setIsSidebarExpanded(false);
        }}
        onKeyDown={(event) => {
          if (event.key === 'Escape') {
            setIsSidebarExpanded(false);
          }
        }}
        tabIndex={0}
      />
      <div
        className={classNames(
          'fixed! top-[60px] z-20 h-[calc(100vh-60px)] overflow-scroll rounded-r-x2 background-subtle px-x4 py-x3 transition-[left] duration-200',
          {
            'left-x0': isSidebarExpanded,
            'left-[-310px]': !isSidebarExpanded
          }
        )}
      >
        <StudentHomepageSidebarContent />
      </div>
    </>
  );
}
